import { Navigate, Outlet } from 'react-router-dom'

import { FormFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

export type TabsIds = 'questions' | 'responses'

type Props = {
  openSidepanel: boolean
  setOpenSidepanel: (value: boolean) => void
  trainingForm?: FormFragment
  trainingId: number
}

export const Form = ({ openSidepanel, setOpenSidepanel, trainingForm, trainingId }: Props) => {
  const { navigation } = useNavigation()

  if (!trainingForm) {
    return (
      <Navigate
        to={navigation.trainings.list.details_revamp.view.surveys.fullPath({
          id: trainingId,
        })}
      />
    )
  } else {
    return (
      <Outlet
        context={{
          trainingForm: trainingForm,
          openSidepanel: openSidepanel,
          setOpenSidepanel: setOpenSidepanel,
        }}
      />
    )
  }
}
